import { useState } from 'react';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Tab, Tabs } from '@optimus-web/core';
import { LocalizedPageTitle, OptimusProvider, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import { WithGuideLink } from '@mews-commander/types';
import { CreateCentralProductButton } from '../CentralProductForm/CreateCentralProductButton';
import { EnterprisesProductContextProvider } from '../../context/EnterprisesProductContext';
import { CentralProductTable } from '../tables/CentralProductTable/CentralProductTable';
import { LocalProductTable } from '../tables/LocalProductTable/LocalProductTable';

enum PRODUCTS_TABS {
    CENTRAL_PRODUCTS = 'CENTRAL_PRODUCTS',
    LOCAL_PRODUCTS = 'LOCAL_PRODUCTS',
}

export const ProductsWrapper = ({ guideLink }: WithGuideLink) => {
    const [activeTab, setActiveTab] = useState<PRODUCTS_TABS>(PRODUCTS_TABS.CENTRAL_PRODUCTS);

    return (
        <OptimusProvider density="spacious">
            <PortfolioLayout>
                <PortfolioLayoutHeader
                    title={<LocalizedPageTitle textKey={TextKey.Products} />}
                    rightSide={
                        <EnterprisesProductContextProvider>
                            <CreateCentralProductButton size="medium" />
                        </EnterprisesProductContextProvider>
                    }
                    guideLink={guideLink}
                />
                <Tabs
                    underline
                    inline
                    onTabClick={(_, value) => setActiveTab(value as PRODUCTS_TABS)}
                    activeTabValue={activeTab}
                >
                    <Tab
                        inline
                        id={PRODUCTS_TABS.CENTRAL_PRODUCTS}
                        value={PRODUCTS_TABS.CENTRAL_PRODUCTS}
                        label={lt('CentralProducts')}
                    />
                    <Tab
                        inline
                        id={PRODUCTS_TABS.LOCAL_PRODUCTS}
                        value={PRODUCTS_TABS.LOCAL_PRODUCTS}
                        label={lt('LocalProducts')}
                    />
                </Tabs>
                {activeTab === PRODUCTS_TABS.CENTRAL_PRODUCTS ? <CentralProductTable /> : <LocalProductTable />}
            </PortfolioLayout>
        </OptimusProvider>
    );
};
